import { theme } from '@noths/polaris-client-ribbons-base';
import { hideScrollbar } from '@noths/polaris-client-styles';
import { palette, typography } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { spacing } = theme;

export const breadcrumbList = css`
  margin: 0;
  list-style-type: none;
  padding: 0;
  white-space: nowrap;
  overflow: scroll;

  ${hideScrollbar}
`;

export const breadcrumbNav = css`
  position: relative;

  &[data-left-fade-visible='true'] {
    &:before {
      content: '';
      position: absolute;
      width: ${spacing.xxl}px;
      height: 100%;
      left: 0;
      top: 0;
      background-image: linear-gradient(
        to left,
        rgba(255, 255, 255, 0.3),
        rgba(255, 255, 255) 100%
      );
    }
  }
`;

export const breadcrumbListItem = css`
  display: inline-block;

  & + li::before {
    border-right: 1px solid var(--neutral-black-30);
    content: '';
    display: inline-block;
    height: ${spacing.sm}px;
    margin: 0 ${spacing.xs}px;
    position: relative;
    top: 2px;
    transform: rotate(15deg);
  }

  &:last-child {
    a,
    span {
      color: ${palette.greyBase};
    }
  }
`;

export const breadcrumbLink = css`
  font-family: ${typography.body.fontFamily};
  font-size: ${typography.body.sizes.sm.fontSize};
  font-weight: ${typography.body.fontWeight};
  text-decoration: none;
  color: ${palette.blueBase};
`;
